import { z } from 'zod';
import { CommerceDate } from './commerce.js';
/** Evidence contract only. This does not import data, grant invoice eligibility, or enable live numbering. */
export const CommerceCutoverEvidenceSchema = z.object({
    version: z.literal(1), sourceSystem: z.literal('EPOS_NOW'), cutoff: CommerceDate,
    history: z.object({ reconciled: z.boolean(), applyStock: z.literal(false), applyDebt: z.literal(false), invoiceEligible: z.literal(false), evidenceReference: z.string().min(1) }).strict(),
    supplierOrderCodeMappingReconciled: z.boolean(),
    openingStockReconciled: z.boolean(), openingAccountBalancesReconciled: z.boolean(),
    outstandingPurchaseOrdersReconciled: z.boolean(), priorInvoiceAllocationsReconciled: z.boolean(),
    liveInvoiceSeriesApproved: z.boolean(), creditNotePolicyApproved: z.boolean(),
}).strict();
export function commerceCutoverBlockers(input) {
    const evidence = CommerceCutoverEvidenceSchema.parse(input), blockers = [];
    if (!evidence.history.reconciled)
        blockers.push('Historical demand and reporting reconciliation');
    const gates = { supplierOrderCodeMappingReconciled: 'Supplier OrderCode mapping', openingStockReconciled: 'Day-one stock', openingAccountBalancesReconciled: 'Opening account balances', outstandingPurchaseOrdersReconciled: 'Outstanding purchase orders', priorInvoiceAllocationsReconciled: 'Prior invoice allocations', liveInvoiceSeriesApproved: 'Live invoice series', creditNotePolicyApproved: 'Credit-note policy' };
    for (const [key, label] of Object.entries(gates))
        if (!evidence[key])
            blockers.push(label);
    return blockers;
}
